<template>
  <el-dialog title="选择要退的材料" :visible.sync="selectMaterialVisible" width="1200px" :show-close="true" class="text-center" :before-close="onClose" append-to-body>
    <div class="content flex-column plr-20 bg-f3f4f7 ptb-10">
      <div class="flex h-30 align-center mb-10">
        <div class="bg-ff flex flex-1 h-30 align-center plr-10 border-ra">
          <div class="flex align-center mr-20 cursor">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-f5971d">材料列表</div>
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class=" font-12-85" type="text" placeholder="请输入单据号" v-model="inputValue" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
      <div class="flex-1 mb-10">
        <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData"></erp-table>
      </div>
    </div>
    <div slot="footer">
      <div class="btn-30-bg-82b925-big mr-10" @click="onClose">取消</div>
      <div class="btn-30-bg-f5971d-s" @click="onSubmit">确定</div>
    </div>
  </el-dialog>
</template>

<script>
import ErpTable from '@/components/ErpTable'
export default {
  name: 'SelectReturnMaterial',
  props: ['selectItem', 'orderDefine'],
  components: {ErpTable},
  data () {
    return {
      selectMaterialVisible: false,
      loading: false,
      inputValue: '',
      page: 1,
      limit: 10,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100, // 总条数
      tableData: [],
      columnData: [{
        field: 'select',
        type: 'selection',
        width: '40',
        fixed: 'left'
      }, {
        field: 'materialCode',
        title: '材料编码',
        width: '120'
      }, {
        field: 'materialName',
        title: '材料名称',
        width: '120'
      }, {
        field: 'materialMode',
        title: '规格型号',
        width: '100'
      }, {
        field: 'materialUnit',
        title: '单位',
        width: '80'
      }, {
        field: 'quantity',
        title: '数量',
        width: '100'
      }, {
        field: 'remark',
        title: '材料说明',
        minWidth: '150'
      }]
    }
  },
  created () {},
  mounted () {},
  methods: {
    getData () {
      let params = {
        orderId: this.selectItem.id,
        keywords: this.inputValue
      }
      if (this.orderDefine.type === 4 || this.orderDefine.type === 5 || this.orderDefine.type === 6 || this.orderDefine.type === 12 || this.orderDefine.type === 13) {
        params.isBack = 2
      }
      this.axios.post(`orderMaterial/list`, params).then(res => {
        if (res.data.success) {
          this.tableData = []
          res.data.data.forEach(i => {
            let arr = ['totalCost']
            if (this.orderDefine.costPriceAdd !== 1) {
              arr.push(this.orderDefine.costPriceField)
            }
            if (i.isModified === -1) {
              let unEditableArr = ['materialCode', 'materialName', 'materialMode', 'materialUnit']
              arr = arr.concat(unEditableArr)
            }
            i.unEditable = arr.join(',')
            this.tableData.push(i)
          })
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    onClose () {
      this.inputValue = ''
      this.tableData = []
      this.selectMaterialVisible = false
    },
    onSubmit () {
      let list = this.$refs.erpTable.getSelectEvent()
      if (list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].quantity <= 0) {
            list.splice(i, 1)
          }
        }
      }
      let addList = []
      if (list.length === 0) {
        this.$message({
          message: `请选择材料`,
          type: 'warning'
        })
      } else {
        list.forEach(i => {
          let arr = ['totalCost']
          if (this.orderDefine.costPriceAdd !== 1) {
            arr.push(this.orderDefine.costPriceField)
          }
          if (i.isModified === -1) {
            let unEditableArr = ['materialCode', 'materialName', 'materialMode', 'materialUnit']
            arr = arr.concat(unEditableArr)
          }
          console.log(i)
          let item = {
            ...i,
            name: i.name,
            unEditable: arr.join(','),
            materialId: i.materialId,
            materialName: i.name,
            materialCode: i.materialCode,
            // materialStandard: i.standard,
            // materialMode: i.model,
            // materialUnit: i.salesUnit,
            // availableQuantity: i.quantity,
            quantity: 1,
            totalCost: i[this.orderDefine.costPriceField],
            customerPrice: i[this.orderDefine.customerPriceField],
            costPrice: i[this.orderDefine.costPriceField],
            projectPrice: i.projectPrice,
            remark: i.remark,
            chargebackId: i.id,
            isModified: i.isModified
          }
          addList.push(item)
        })
        console.log(addList)
        this.selectMaterialVisible = false
        this.$parent.$parent.selectVisible = false
        this.$parent.$parent.$parent.$parent.chargebackCode = this.selectItem.code
        this.$parent.$parent.$parent.$parent.chargebackId = this.selectItem.id
        this.$parent.$parent.$parent.$parent.businessId = this.selectItem.businessId
        this.$parent.$parent.$parent.$parent.businessName = this.selectItem.businessName
        this.$parent.$parent.$parent.$parent.storehouseId = this.selectItem.storehouseId
        this.$parent.$parent.$parent.$parent.storehouseName = this.selectItem.storehouseName
        this.$parent.$parent.$parent.$parent.customerId = this.selectItem.customerId
        this.$parent.$parent.$parent.$parent.customerName = this.selectItem.customerName
        this.$parent.$parent.$parent.$parent.customerAddress = this.selectItem.customerAddress
        this.$parent.$parent.$parent.$parent.billList = this.selectItem
        this.$parent.$parent.$parent.$parent.isChargeback = true
        this.$parent.$parent.$parent.$parent.tableData = addList
        this.$refs.erpTable.setAllSelection(false)
      }
    }
  },
  watch: {
    inputValue (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 500px;
  }
  .el-form-item{
    margin-bottom: 0px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .content /deep/ .el-input__icon{
    color: #30313a;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/SelectReturnMaterial.vue